import { Dispatch } from 'react';
import { api } from '../root';
import { addNotification } from '../../store/notifications/slice';
import { handleRequestErrors } from 'helpers/functions/commons';

export const getAllAnalogueSettingTags = async (thunkAPI: unknown) => {
    try {
        const response = await api.get('/AnalogueWorkSpace/getAllAnalogueSettingTags');
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const addAnalouePlot = async (data: {workspaceId: string, title: string}, thunkAPI: unknown) => {
    try {
        const response = await api.post('/AnalogueWorkSpace/addNewAnaloguePlot', {title: data.title, workspaceId: data.workspaceId});
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const getAllAnaloguePlotList = async (workspaceId: string, thunkAPI: unknown) => {
    try {
        const response = await api.get(`/AnalogueWorkSpace/GetAll/${workspaceId}`);
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const removeAFPlot = async (id: string, thunkAPI: unknown) => {
    try {
        const response = await api.delete(`/AnalogueWorkSpace/${id}`);
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const getBroadFilterParameter = async (id: string, thunkAPI: unknown) => {
    try {
        const response = await api.get(`/AnalogueWorkSpace/getBroadFilterParameter/${id}`);
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const addBroadFilterParameter = async (data: {itemId: string, workSpaceId: string}, thunkAPI: unknown) => {
    try {
        const response = await api.get(`/AnalogueWorkSpace/addBroadFilterParameter/${data.itemId}/${data.workSpaceId}`);
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const deleteBroadFilterParameter = async (data: {id: string, workSpaceId: string}, thunkAPI: unknown) => {
    try {
        const response = await api.delete(`/AnalogueWorkSpace/deleteBroadFilterParameter/${data.id}/${data.workSpaceId}`);
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const resetBroadFilterParameter = async ( thunkAPI: unknown) => {
    try {
        const response = await api.get(`/AnalogueWorkSpace/resetBroadFilterParameter`);
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const getResultTagList = async ( thunkAPI: unknown) => {
    try {
        const response = await api.get(`/AnalogueWorkSpace/getResultTagList`);
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}

export const getGridColumnsData = async ( data:{id: string, columns: string[] }, thunkAPI: unknown) => {
    try {
        const response = await api.post(`/AnalogueWorkSpace/getGridColumns/${data.id}`, {ids: data.columns});
        return response.data;
    } catch (e: unknown) {  
        const validationMessage = handleRequestErrors(e)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: any) => any, dispatch: Dispatch<unknown> }
        thunkRejectError.dispatch(addNotification({ type: 'error', message: validationMessage }));
        return thunkRejectError.rejectWithValue(validationMessage);
    }
}
